<template>
    <div class="performance">
        <div class="performance__main">
            <div class="performance__date-time">
                <span class="performance__date">{{ formattedDate }}</span>
                <span class="performance__day-time">{{ formattedDayTime }}</span>
            </div>
            <span class="performance__subtitle" v-if="props.performance.attributes?.custom?.subtitle">{{ props.performance.attributes.custom.subtitle }}</span>
            <a
                class="performance__book-button btn btn--small"
                v-if="props.performance.ctaPrimary?.link && bookable"
                :href="props.performance.ctaPrimary.link"
            >
                <span class="performance__book-button-label">{{ props.performance.ctaPrimary.title }}</span>
                <svg class="o-icon o-icon--arrow-right" aria-hidden="true"><use xlink:href="#arrow-right"></use></svg>
            </a>
            <span
                class="btn btn--small performance__book-button performance__book-button--not-bookable"
                v-else-if="props.performance.isSoldOut"
            >Sold Out</span>
            <span
                class="btn btn--small performance__book-button performance__book-button--not-bookable"
                v-else-if="!bookable"
            >Unavailable</span>
        </div>

        <div class="performance__footer">
            <ul class="performance__tags" v-if="tags.length">
                <li class="performance__tag" v-for="tag in tags" :key="tag">{{ tag.trim() }}</li>
            </ul>
            <!-- <Availability v-if="bookable && featureEnabled('performance.availability')" :event="props.performance" /> -->
        </div>
    </div>
</template>

<script setup>
import { format } from 'date-fns';

// import Availability from './Availability.vue';
import { computed, ref } from 'vue';
// import { isBookable } from '../../services/performance';

const props = defineProps({
    performance: {
        type: Object,
        required: true,
    }
});

const featureEnabled = window.featureEnabled; //Required for access in template

// const bookable = computed(() => isBookable(props.performance));
const bookable = ref(true); // Temporary until booking logic is implemented

const formattedDate = computed(() => {
    return format(props.performance.performancedate, 'MMMM d');
});

const formattedDayTime = computed(() => {
    const mins = format(props.performance.performancedate, 'mm');
    const time = mins === '00'
        ? format(props.performance.performancedate, 'haaa')
        : format(props.performance.performancedate, 'h:mmaaa');
    return format(props.performance.performancedate, 'EEEE, ') + time;
});

const tags = computed(() => props.performance.accessibility ?? []);
</script>
